import InfoPerfil from "./InfoPerfil";
import { Link, useLocation } from "react-router-dom";
import TablaPropiedades from "../Propiedades/TablaPropiedades";
import Back from "../../assets/Back";
import PropietariodNavegacionMobile from "./PropietarioNavegacionMobile";
import { Divider, Grid } from "@mui/material";

const isMobile =
    !!navigator.userAgent.match(/iphone|android|blackberry/gi) || false;

const PerfilPropietario = () => {
  let { search } = useLocation();
  let query = new URLSearchParams(search);
  let perfil = query.get("id");

  return (
    <div className="contenido">
      <Back urlPath={"/propietarios"} />
      <InfoPerfil idCliente={perfil} />
      { !isMobile ? (
        <div className="opciones">
          <Link to={`/propietarios/propiedades?id=${perfil}`}>
            <h3
              className="opcionPropiedades"
              id={
                window.location.pathname.includes("propiedades")
                  ? "active1"
                  : "notActive1"
              }
            >
              Propiedades
            </h3>
          </Link>
          <Link to={`/propietarios/actividades?id=${perfil}`}>
            <h3
              className="opcionActividades"
              id={
                window.location.pathname.includes("actividades")
                  ? "active1"
                  : "notActive1"
              }
            >
              Actividades
            </h3>
          </Link>
        </div>
      ) : (
        <PropietariodNavegacionMobile id={perfil} />
      )}
      
      {isMobile && (
        <Grid container justifyContent={"flex-start"} className="alignLeft" sx={{marginTop: 2}}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Divider variant="middle" sx={{ mb: 2, backgroundColor: "black" }} />
          </Grid>
          <Grid item>
            <h2>Propiedades</h2>
          </Grid>
        </Grid>
      )}
      <TablaPropiedades idBroker={""} idCliente={perfil} incluirFiltro={false} incluirBotonCrearPropiedad={true} />
    </div>
  );
};

export default PerfilPropietario;
